// extracted by mini-css-extract-plugin
export default {"AddSuppliers":"AddSuppliers_AddSuppliers__7a-XE"};